<template>
  <v-dialog
    v-model="dialog"
    :width="step == 0? '510px': '330px'">
    <div
      class="dialog-container"
      :style="{padding:step==0?'':'15px'}">
      <template v-if="step == 0">
        <div class="plan-header">
          <div class="info flex">
            <h3>Make Cover Note</h3>
            <i
              class="el-icon-close"
              @click="onCancle"></i>
          </div>
        </div>
        <div class="dialog-body">
          <el-form
            ref="form"
            :rules="rules"
            :model="formData">
            <div class="item-content">
              <div class="form-item">
                <span>Cover Effective Date</span>
                <div class="">
                  <el-form-item
                    ref="cvr_nt_eff_dt"
                    :rules="rules.select"
                    prop="cvr_nt_eff_dt">
                    <v-datetime-picker
                      v-model="formData.cvr_nt_eff_dt"
                    />
                  </el-form-item>
                </div>
              </div>
              <div class="form-item">
                <span>Cover Note Effective Days</span>
                <el-form-item
                  ref="cvr_nt_isrd_days"
                  :rules="rules.select"
                  prop="cvr_nt_isrd_days">
                  <v-select
                    v-model="formData.cvr_nt_isrd_days"
                    :list="cvr_days_list"
                  />
                </el-form-item>
              </div>
            </div>
          </el-form>
        </div>
        <div class="dialog-footer">
          <v-button @click="onCancle">Cancel</v-button>
          <v-button
            type="primary"
            @click="onContinue">Continue</v-button>
        </div>
      </template>
      <template v-else>
        <send-email-sms
          ref="send-email-sms"
          :form="form"
          :initContent="form.cover_note_url_data"
          :emailListTitle="emailListTitle"
          :emailTitle="emailTitle"
          @cancel="onSkip"
          @send="onSend"
          @skip="onSkip" />
      </template>
    </div>

  </v-dialog>
</template>
<script>
import MixinRules from '@/mixins/rules'
import MixinOptions from '@/mixins/options'
import {
  RebuildPDF,
  sendOrderIssueIssuingNotice
} from '@/api/order'
import SendEmailSms from './send-email-sms'

export default {
  name: 'MarkAsIssuingDialog',
  components: {
    SendEmailSms
  },
  mixins: [MixinOptions,MixinRules],
  props: {
    form: {
      type: Object,
      default: () => ({})
    },
    orderId: {
      type: [String, Number],
      default: ''
    },
    value:{
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      dialog: false,
      step: 0,
      formData: {
        cvr_nt_isrd_days: '',
        cvr_nt_eff_dt:''
      },
    }
  },
  computed:{
    cvr_days_list(){
      let {cover_note_effective=[]}  = this.globalOptions||{}
      return cover_note_effective||[]
    },
    emailListTitle(){
      return this.form.cover_note_url_list_title || ''
    },
    emailTitle(){
      return this.form.cover_note_url_title || ''
    },
  },
  watch: {
    value:{
      immediate:true,
      handler(val){
        this.step = 0
        this.dialog =val
      }
    },
    dialog: {
      immediate: true,
      handler(val) {
        if(val) {
          const { cvr_eff_dt,cvr_nt_isrd_days } = this.form
          this.formData.cvr_nt_eff_dt = cvr_eff_dt
          this.formData.cvr_nt_isrd_days = cvr_nt_isrd_days
        }
      }
    }
  },
  methods: {
    onContinue() {
      this.$refs['form'].validate((valid, rules) => {
        if(valid) {
          this.network().RebuildCoverPDF(this.formData)
        }
        else {
          console.log(rules)
        }
      })
    },
    onSend(data) {
      this.network().sendOrderIssueIssuingNotice({content:data.content})
    },
    onCancle(){
      this.$emit('input',false)
    },
    onSkip() {
      this.$emit('input',false)
      this.$emit('update')
      // this.step = 0
    },
    network() {
      return {
        RebuildCoverPDF: async (params) => {
          const {data} = await RebuildPDF({order_id: this.orderId,type:'cvr_pdf_path',...params})
          this.step=1
        },
        sendOrderIssueIssuingNotice: async (params) => {
          const { data } = await sendOrderIssueIssuingNotice({
            order_id: this.orderId,
            ...params
          })
          this.$emit('input',false)
          this.$emit('update')
          // this.step = 0
          // this.$emit('update')
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.dialog-container {
  .dialog-body{
    padding: 15px;
  }
  .plan-header {
    //padding: 15px;
    background: #F6F8FA;
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
    .info{
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding:10px 10px 10px 10px;
      font-size: 14px;
      font-weight: 600;
      color: #24292E;
      i{
        font-weight: 600;
        font-size: 14px;
      }
    }
  }
  .form-item{
   &:last-child{
     padding-bottom: 0;
   }
  }
  .item-content{
    padding-bottom: 30px;
    padding-top: 20px;
  }
  .title-span{
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    line-height: 24px;
    color: #24292E;
    margin-top: 30px;
  }
  h3 {
    padding-bottom: 5px;
  }
  p {
    padding-bottom: 10px;
  }
  .dialog-footer {
    padding: 15px;
    text-align: right;
    background: #F9FAFB;
    display: flex;
    justify-content: space-between;
  }
  .form-item {
    & > span {
      //font-weight: bold;
      //font-size: 16px;
    }
  }
  .flex-align{
    align-items: center;
    .margin-time{
      margin: 0 10px;
    }
  }
}
</style>
